import React from "react";
import { Outlet } from 'react-router-dom';
import { Grid, theme } from "antd";
import HeaderDefault from "../HeaderDefault/HeaderDefault";
import FooterDefault from "../FooterDefault/FooterDefault";

const { useToken } = theme;
const { useBreakpoint } = Grid;
const FullWidthCenteredLayout = () => {
    const { token } = useToken();
    const screens = useBreakpoint();

    const styles = {
        container: {
            margin: "0 auto",
            maxWidth: screens.lg ? token.screenXL : token.screenSM,
        },
        placeholder: {
            borderRadius: token.borderRadiusLG,
            textAlign: "center"
        },
        section: {
            height: screens.sm ? "100vh" : "auto",
            backgroundColor: "#f3f4f8",
        }
    };

    return (
        <div style={styles.section} >
            <HeaderDefault />
            <div style={{ width: screens.lg ? '100%' : '100%', padding: screens.lg ? "20px 30px 20px" : "10px 10px 10px", height: "calc(100vh - 110px)", overflow: "auto" }}>
                <div style={styles.container}>
                    <div style={styles.placeholder} data-testid="outlet">
                        <Outlet />
                    </div>
                </div>
            </div>
            <div data-testid="footer-default">
                <FooterDefault />
            </div>

        </div>
    );
}
export default FullWidthCenteredLayout;